import React, { Component } from 'react'
import CacheKeys from '../../../cache/CacheKeys'
import CacheManager from '../../../cache/CacheManager'
import RestApiUtils from '../../../apiclient/moebli/RestApiUtils'
import LeadDashboardPageUI from './LeadDashboardPageUI.js'

class LeadDashboardPageSF extends Component {
  constructor(props) {
    super(props)
    this.state = {
      errorList: null,
      leadDashboardList: null,
      accountList: null,
      originatorList: [],
      salesChannelList: [],
      selectedEntry: null,
      createEntryMode: false,
      updateEntryMode: false,
      sendEmailMode: false,
      emailTemplateList: [],
    }
  }

  render() {
    return (
      <LeadDashboardPageUI
        context={this.props.context}
        errorList={this.state.errorList}
        leadDashboardList={this.state.leadDashboardList}
        accountList={this.state.accountList}
        originatorList={this.state.originatorList}
        salesChannelList={this.state.salesChannelList}
        onRefreshClick={this.onRefreshClick}
        //
        selectedEntry={this.state.selectedEntry}
        createEntryMode={this.state.createEntryMode}
        onCreateEntryClick={() => { this.setState({ createEntryMode: true }) }}
        onCreateEntryCancel={this.onCreateEntryCancel}
        //
        updateEntryMode={this.state.updateEntryMode}
        onUpdateEntryClick={this.onUpdateEntryClick}
        onCancelUpdateEntry={this.onCancelUpdateEntry}
        //
        sendEmailMode={this.state.sendEmailMode}
        onSendEmailClick={this.onSendEmailClick}
        onCancelSendEmail={this.onCancelSendEmail}
        emailTemplateList={this.state.emailTemplateList}
      />
    )
  }

  componentDidMount() {
    let context = this.props.context
    this.getLeadDashboardList(context)
    this.getAccounts(context)
    this.getOriginators(context)
    this.getSalesChannels(context)
    this.getEmailTemplates(context)
  }

  getLeadDashboardList(context) {
    let cacheManager = new CacheManager({
      resource: `/api/su/leadDashboard`,
      cacheKey: CacheKeys.LeadDashboard(),
      callback: this.getLeadDashboardListCallback,
      ttlInSecs: 600,
    })
    cacheManager.getObject2(context)
  }

  getLeadDashboardListCallback = (response) => {
    this.setState({ errorList: response.errorList, leadDashboardList: response.leadDashboardList })
  }

  getAccounts(context) {
    let cacheManager = new CacheManager({
      resource: `/api/su/accounts`,
      cacheKey: CacheKeys.Accounts(context.session.userId, context.filter),
      callback: this.getAccountsCallback,
      ttlInSecs: 3600
    })
    cacheManager.getObject2(context, {}, { stp: context.filter === 'stp' })
  }

  getAccountsCallback = (response) => {
    let sortedList = (response.accountList || []).slice().sort((a, b) => {
      return (b.dateCreated || 0) - (a.dateCreated || 0)
    })
    this.setState({ accountList: sortedList })
  }

  getOriginators(context) {
    let cacheManager = new CacheManager({
      resource: `/api/su/superusers`,
      cacheKey: CacheKeys.SuperUsers(),
      callback: this.getOriginatorsCallback,
      ttlInSecs: 3600
    })
    cacheManager.getObject2(context)
  }

  getOriginatorsCallback = (response) => {
    let originatorList = (response.userList || []).map(user => ({
      key: user.userId,
      value: user.addressableName
    }))
    this.setState({ originatorList: originatorList })
  }

  getSalesChannels(context) {
    let cacheManager = new CacheManager({
      resource: `/api/reference/salesChannels`,
      cacheKey: CacheKeys.SalesChannel(),
      callback: this.getSalesChannelsCallback,
      ttlInSecs: 3600
    })
    cacheManager.getObject2(context)
  }

  getSalesChannelsCallback = (response) => {
    let salesChannelList = (response.salesChannelList || []).map(channel => ({
      key: channel.code,
      value: channel.name
    }))
    this.setState({ salesChannelList: salesChannelList })
  }

  getEmailTemplates(context) {
    let cacheManager = new CacheManager({
      resource: `/api/su/leadDashboard/emailTemplates`,
      cacheKey: CacheKeys.LeadDashboardEmailTemplates(),
      callback: this.getEmailTemplatesCallback,
      ttlInSecs: 3600
    })
    cacheManager.getObject2(context)
  }

  getEmailTemplatesCallback = (response) => {
    this.setState({ emailTemplateList: response.templateList })
  }

  onCreateEntryCancel = () => {
    this.setState({ createEntryMode: false, errorList: null })
  }

  onUpdateEntryClick = (event) => {
    let leadDashboardId = event.currentTarget.getAttribute('data-lead-dashboard-id')
    let accountId = event.currentTarget.getAttribute('data-account-id')
    let selectedEntry = this.state.leadDashboardList.filter(l =>
      leadDashboardId ? l.leadDashboardId === leadDashboardId : l.accountId === accountId
    )[0]
    this.setState({ updateEntryMode: true, selectedEntry: selectedEntry })
  }

  onCancelUpdateEntry = () => {
    this.setState({ updateEntryMode: false, selectedEntry: null, errorList: null })
  }

  onSendEmailClick = (event) => {
    let leadDashboardId = event.currentTarget.getAttribute('data-lead-dashboard-id')
    let accountId = event.currentTarget.getAttribute('data-account-id')
    let selectedEntry = this.state.leadDashboardList.filter(l =>
      leadDashboardId ? l.leadDashboardId === leadDashboardId : l.accountId === accountId
    )[0]
    this.setState({ sendEmailMode: true, selectedEntry: selectedEntry })
  }

  onCancelSendEmail = () => {
    this.setState({ sendEmailMode: false, selectedEntry: null, errorList: null })
  }

  onRefreshClick = (noBusy) => {
    let context = this.props.context
    CacheManager.removeObject(CacheKeys.LeadDashboard())
    if (noBusy === 'noBusy') {
      this.getLeadDashboardList(context)
    } else {
      this.setState({ leadDashboardList: null, errorList: null }, () => {
        this.getLeadDashboardList(context)
      })
    }
  }
}

export default LeadDashboardPageSF